import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { LayoutContext } from "../../../store/context/layout-context";
import SVG_CLOSE_GREY from "../../../assets/images/vector/Layout/Popup/close_popup.svg";
import { POPUP_TYPES } from "../../../helpers/constants";
import { MOBILE_PRO_POPUP_MODES } from "../MobileProPopup/index.content";
import { MODES } from "../../Paywalls/Customizable/content/index.content";
import { getTrueClasses } from "../../../helpers";
import track from "../../../tracking/analytics";
import CustomizableContainer from "../../../containers/Paywalls/Customizable/CustomizableContainer";
import MobileProPopup from "../MobileProPopup";
import YouTube from "../YouTube";
import "./index.scss";

const Popup = (props) => {
  const { language = "en", addOnDefault, type = POPUP_TYPES.PAYWALL } = props;
  const { openPopup, closePopup, popupState } = useContext(LayoutContext);
  const [pathname, setPathname] = useState("");
  const modalRef = useRef(null);
  const pricingRef = useRef(null);
  const youTubeId = popupState.youTubeId ? popupState.youTubeId : "UCUEItN0ONc";
  const mobilePopupOpenHandler = (action = "") => {
    if (window !== undefined) {
      setPathname(window.location.pathname || "");
      const category = "MobileProPopup";
      const label = window.location.href || "";
      track(category, action, label);
    }
  };
  const closePopupHandler = useCallback(() => {
    console.log(type, popupState.isModal);
    if (type === POPUP_TYPES.YOU_TUBE && popupState.isModal) {
      openPopup(POPUP_TYPES.PAYWALL);
    } else {
      closePopup();
    }
  }, [type, popupState.isModal]);

  useEffect(() => {
    const htmlElement = document.documentElement;
    const handleKeyEsc = (e) => {
      e.key === "Escape" && closePopupHandler();
    };

    htmlElement.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyEsc);
    type === POPUP_TYPES.MOBILE_PRO &&
      mobilePopupOpenHandler("pro_mobile_popup");
    type === POPUP_TYPES.MOBILE_OA && mobilePopupOpenHandler("oa_mobile_popup");
    return () => {
      htmlElement.style.overflow = "auto";
      document.removeEventListener("keydown", handleKeyEsc);
    };
  }, [type, popupState.isModal]);

  return (
    <div className="GCL-P">
      <div className="GCL-P-window">
        <div
          ref={modalRef}
          className={getTrueClasses(
            "GCL-P-container",
            type === POPUP_TYPES.YOU_TUBE && "GCL-P-container_youTube"
          )}
        >
          <button className="GCL-P__close" onClick={closePopupHandler}>
            {type !== POPUP_TYPES.YOU_TUBE && (
              <img src={SVG_CLOSE_GREY} alt="x" />
            )}
          </button>
          <div className="GCL-P-body">
            {type === POPUP_TYPES.PAYWALL && (
              <CustomizableContainer
                mode={MODES.modal}
                modalRef={modalRef}
                pricingRef={pricingRef}
                language={language}
                advancedReselling={addOnDefault}
              />
            )}
            {(type === POPUP_TYPES.MOBILE_PRO ||
              type === POPUP_TYPES.MOBILE_OA) && (
              <MobileProPopup
                language={language}
                mode={
                  MOBILE_PRO_POPUP_MODES[
                    type === POPUP_TYPES.MOBILE_OA ? "oa" : pathname
                  ]
                }
              />
            )}
            {type === POPUP_TYPES.YOU_TUBE && <YouTube youTubeId={youTubeId} />}
          </div>
        </div>
      </div>
      <div className="GCL-P__shadow" />
    </div>
  );
};

Popup.propTypes = {
  language: PropTypes.string,
  addOnDefault: PropTypes.bool,
  type: PropTypes.string,
};

export default Popup;
